import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: '#52B788',
    title: 'Producción rural',
    emoji: '🌾'
  }, {
    color: '#40916C',
    title: 'Problemáticas ambientales',
    emoji: '🌱'
  }, {
    color: '#2D6A4F',
    title: 'Actividad agropecuaria',
    emoji: '🚜'
  }, {
    color: '#1B9AAA',
    title: 'Territorio y sociedad',
    emoji: '🌎'
  }, {
    color: '#6B8E23',
    title: 'Análisis geográfico aplicado',
    emoji: '📊'
  }, {
    color: '#D4A843',
    title: 'Geografía rural completa',
    emoji: '🧭'
  }];
  return <section className="bg-[#0F2E23] pb-4 md:pb-6 px-3 border-b border-[#1F3D2B]" data-id="element-225">
      <div className="max-w-4xl mx-auto" data-id="element-226">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2" data-id="element-227">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className="bg-[#102A1F] rounded-xl p-3 text-center cursor-pointer transform hover:scale-105 hover:border-[#D4A843] hover:shadow-[0_0_20px_rgba(212,168,67,0.3)] transition-all duration-300 flex flex-col justify-center items-center border border-transparent" data-id="element-228">
              <div className="text-2xl md:text-3xl mb-1.5" data-id="element-229">{tomo.emoji}</div>
              <h4 className="font-black text-[10px] md:text-xs leading-tight uppercase" style={{
            color: tomo.color
          }} data-id="element-230">
                {tomo.title}
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}